import { render } from "./App.vue?vue&type=template&id=3162d4e9&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=3162d4e9&scoped=true&lang=css"

import exportComponent from "D:\\GitHub\\lexoh-parking-ionic\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3162d4e9"]])

export default __exports__